module.exports = __webpack_public_path__ + "static/media/gallery_preview.50fce2a5.png";